module.exports = __webpack_public_path__ + "static/media/critical_illness_myway.cfb772a2.svg";